export enum HookType {
  EVENT = 'event',
  AD_BREAK = 'adbreak',
  AD = 'ad',
}
